const e = (r) => r.type === "apiKey" ? {
  ...r,
  "x-scalar-secret-token": r.value
} : r.type === "http" ? {
  ...r,
  "x-scalar-secret-token": r.token,
  "x-scalar-secret-username": r.username,
  "x-scalar-secret-password": r.password
} : r.type === "oauth2" ? {
  ...r,
  flows: Object.fromEntries(
    Object.entries(r.flows).map(([a, t]) => [
      a,
      t && {
        ...t,
        "x-scalar-secret-token": t.token
      }
    ])
  )
} : r;
export {
  e as convertSecurityScheme
};
